import React from "react";
import { Link } from "react-router-dom";
import * as Styled from "./styled";
import InputPhoneNumber from "../../../../Input/PhoneNumber";

const FormSigninPhone = ({
  handleSubmitForm = () => {},
  handleChangeForm = () => {},
  onClickBackForm = () => {},
  phone,
  children,
  errorMessage,
}) => {
  const isValidInput = () => {
    if (phone) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Styled.Form onSubmit={handleSubmitForm}>
      <i
        className="fas fa-chevron-circle-left fa-1x"
        style={{
          marginBottom: 15,
          color: "var(--color-primary)",
        }}
        onClick={onClickBackForm}
      ></i>
      <Styled.Paragraph>
        Olá!
        <br />
        Qual o seu celular cadastrado?
      </Styled.Paragraph>
      <InputPhoneNumber
        label="Seu número de celular"
        name="phone"
        type="phone"
        value={phone}
        required={true}
        onChange={handleChangeForm}
      />
      <Styled.ContentButtons
        style={{
          border: errorMessage ? "solid 1px #dadce0" : "none",
        }}
      >
        {children}
        <button
          disabled={isValidInput() ? false : true}
          style={{ opacity: isValidInput() ? 1 : 0.5 }}
        >
          Continuar
        </button>
        <Link to="/signup" style={{ alignSelf: "center" }}>
          Não tem uma conta?
        </Link>
      </Styled.ContentButtons>
    </Styled.Form>
  );
};

export default FormSigninPhone;
